export default __webpack_public_path__ + "static/media/bg_banner_04_small.6307fc65f7139f9ea9badb9a23a447b2.svg";